<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.journalentry') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.status == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.status == 'pending'"
                    class="badge badge-warning">{{ $t('status.jv.pending') }}</span>
                  <span
                    v-if="query.status == 'rejected'"
                    class="badge badge-danger">{{ $t('status.jv.rejected') }}</span>
                  <span
                    v-if="query.status == 'approved'"
                    class="badge badge-success">{{ $t('status.jv.approved') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        class="text-warning"
                        value="pending">
                        {{ $t('status.jv.pending') }}
                      </option>
                      <option
                        class="text-danger"
                        value="rejected">
                        {{ $t('status.jv.rejected') }}
                      </option>
                      <option
                        class="text-success"
                        value="approved">
                        {{ $t('status.jv.approved') }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.jv') }}</th>
              <th>{{ $t('apps.accounting.label.created_at') }}</th>
              <th>{{ $t('apps.accounting.label.jv_type') }}</th>
              <!-- <th>{{ $t('apps.accounting.label.jv_ref') }}</th> -->
              <th>{{ $t('apps.accounting.label.description') }}</th>
              <th>{{ $t('apps.accounting.label.total') }}</th>
              <th>{{ $t('apps.accounting.label.status') }}</th>
              <th>{{ $t('apps.accounting.label.created_by') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="journalEntries.length === 0"
                colspan="8"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in journalEntries"
              :key="index"
            >
              <td>
                <router-link-custom
                  :to="{name: 'AccountsJournalEntryEdit', query: {
                    jv_id: item._id,
                    jv_code: item.jv_code
                  }}"
                  :text="item.jv_code"
                  :to_appid="12"
                  :current_appid="12"/>
              </td>
              <td>
                {{ getDate(item.created_at) }}
              </td>
              <td>
                {{ getMasterDataText(item.jv_type, $t) }}
              </td>
              <!-- <td>
                -
              </td> -->
              <td>
                {{ replaceCodeToText(item.description, $t) }}
              </td>
              <td>
                {{ getNumber(item.total) }}
              </td>
              <td>
                <span
                  :class="[
                    { 'text-warning': item.status == 'pending' },
                    { 'text-danger': item.status == 'rejected' },
                    { 'text-success': item.status == 'approved' }
                ]">
                  {{ $t(`status.jv.${item.status}`) }}
                </span>
              </td>
              <td>
                {{ item.created_by_username }}
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import { getMasterDataText } from '@/helpers'

export default {
  data () {
    return {
      getMasterDataText,
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      journalEntries: 'journalEntries',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 6,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 0,
    })
  },
  methods: {
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getListJournalEntries', {
        params: {
          page: this.query.page,
          limit: this.$store.state.app.limitRowsPerpage,
          status: (() => {
            return this.query.status !== 'all'
              ? this.query.status
              : null
          })(),
        },
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/journalentry/All.vue